export default "skymp5-front/c3f0ce7307ae5d17c8a0a6faedb739fe.svg";